/* eslint-disable no-alert */
import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

import { Icon, Popup, Label, Table, Button } from 'semantic-ui-react'

import firebase from '../../config/firebase'

class RestaurantRow extends PureComponent {
  state = {
    removing: false,
  }

  onDeletePress() {
    const { fireKey, data } = this.props
    const { name, status } = data

    if (status === 'publish') {
      const confirm = window.confirm(
        'Restaurant already published you need to draft first before remove it. Do you want to Draft it?'
      )

      if (confirm) {
        firebase
          .database()
          .ref(`/restaurants/${fireKey}`)
          .update({ status: 'draft' })
      } else {
        return
      }
    } else {
      const confirm = window.confirm(`Are you sure to delete ${name}?`)

      if (confirm) {
        this.setState({ removing: true })

        firebase
          .database()
          .ref(`/restaurants/${fireKey}`)
          .update({ status: 'archived' })
          .then(() => {
            this.setState({ removing: false })
          })
      }
    }
  }

  generateDeepLink = platform => {
    const { fireKey: restoKey } = this.props

    if (platform === 'ios') {
      const iosLink = `muuveapp://resto/${restoKey}`
      return iosLink
    }

    const androidLink = `https://com.muuve.muuve/resto/${restoKey}`
    return androidLink
  }

  renderTierColor = tier => {
    if (tier === 1) {
      return 'green'
    }

    return 'orange'
  }

  renderMerchantType = () => {
    const { data } = this.props

    switch (data.merchant_type) {
      case 'f-and-b':
        return <Label color='blue' horizontal>F & B</Label>

      case 'mart':
        return <Label color='green' horizontal>Mart</Label>

      default:
        return null
    }
  }

  renderLinkButton = () => (
    <Popup
      trigger={<Button size="tiny">Link</Button>}
      position="top left"
      hideOnScroll
      wide="very"
      on="click"
    >
      <div>
        <Label>
          <Icon size="large" name="android" color="green" />
          {this.generateDeepLink('android')}
        </Label>
      </div>
      <div style={{ marginTop: 5 }}>
        <Label>
          <Icon size="large" name="apple" color="green" />
          {this.generateDeepLink('ios')}
        </Label>
      </div>
    </Popup>
  )

  render() {
    const { removing } = this.state
    const { listNumber, fireKey, data } = this.props
    const { name, discount_rate: commission } = data

    return (
      <Table.Row>
        <Table.Cell style={{ width: '20%', fontWeight: 'bold' }}>{`${listNumber}. ${name}`}</Table.Cell>
        <Table.Cell style={{ width: '20%' }} textAlign="center">
          {`${commission} %`}{' '}
        </Table.Cell>
        <Table.Cell style={{ width: '10%' }} textAlign="center">
          {data.tier > 0 ? (
            <Label color={this.renderTierColor(data.tier)} horizontal>
              Tier {data.tier}
            </Label>
          ) : null}
        </Table.Cell>
        <Table.Cell style={{ width: '20%' }} textAlign="center">
          {this.renderMerchantType()}
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Link to={`/restaurants/detail/${fireKey}`}>
            <Button secondary size="tiny">
              View
            </Button>
          </Link>
          <Link to={`/restaurants/${fireKey}/edit`}>
            <Button size="tiny"> Edit </Button>
          </Link>
          <Button loading={removing} color="red" size="tiny" onClick={() => this.onDeletePress()}>
            Delete
          </Button>
          {this.renderLinkButton()}
        </Table.Cell>
      </Table.Row>
    )
  }
}

export default RestaurantRow



// WEBPACK FOOTER //
// ./src/components/restaurants/row.js